var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-search',{attrs:{"add-and-filter-persmission":false,"default-role":_vm.user.profile.roleid,"default-application":_vm.appId,"download-file":_vm.downloadFile,"get-messages":_vm.getMessages}})
}
var staticRenderFns = []

export { render, staticRenderFns }